export default __webpack_public_path__ + "static/media/48.2a094550.jpg";